import React from "react";

const ErrorResponse = ({ title, type, message }) => {
  return (
    <div className={`alert alert-${type} text-center`}>
      <h4>{title ? title : "Error Encountered"}</h4>
      <hr />
      {message}
    </div>
  );
};

export default ErrorResponse;
